import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { logout } from "./slices/authSlice";

const PUBLIC_ROUTES = [
  "/",
  "/signin",
  "/signup",
  "/forgot-password",
  "/new-password",
  "/not-found",
  "/privacy-policy",
  "/terms-conditions",
];
const PRIVATE_REDIRECT = "/home";

const isTokenExpired = (token) => {
  if (!token) return true;
  const decoded = jwtDecode(token);
  return decoded.exp < Date.now() / 1000;
};

const AuthWatcher = () => {
  const { access, refresh } = useSelector((state) => state?.auth?.token) || {};
  const { is_verified, is_more_details } =
    useSelector((state) => state?.auth?.user) || {};

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (location.pathname === "/not-found" || location.pathname === "*") {
      return;
    }
    const isPublicRoute = PUBLIC_ROUTES.includes(location.pathname);
    const accessExpired = isTokenExpired(access);
    const refreshExpired = isTokenExpired(refresh);

    if (accessExpired && refreshExpired) {
      dispatch(logout());
      if (!isPublicRoute) navigate("/");
      return;
    }

    if (access && isPublicRoute) {
      navigate(PRIVATE_REDIRECT);
      return;
    }

    if (!access && !isPublicRoute) {
      navigate("/");
      return;
    }

    if (!is_verified) {
      navigate(PRIVATE_REDIRECT);
      return;
    } else {
      if (!is_more_details) {
        navigate("/moredetails");
        return;
      }
    }
  }, [
    access,
    refresh,
    is_more_details,
    is_verified,
    location.pathname,
    navigate,
    dispatch,
  ]);

  return null;
};

export default AuthWatcher;
